/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbox_SaveInputs */

const en_inbox_save = /** @type {(inputs: Inbox_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save to my recipes`)
};

const de_inbox_save = /** @type {(inputs: Inbox_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu meinen Rezepten`)
};

/**
* | output |
* | --- |
* | "Save to my recipes" |
*
* @param {Inbox_SaveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const inbox_save = /** @type {((inputs?: Inbox_SaveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_SaveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_inbox_save(inputs)
	return en_inbox_save(inputs)
});